module.exports = __webpack_public_path__ + "img/15.925e45ff.png";